module.exports = __webpack_public_path__ + "img/zenfone_live_L1_black.c0f803d1.png";